/** M5 (2026-09-14): blank emails get firstname.p2@aura-ss.local, replaced later. */
export const PLACEHOLDER_DOMAIN = 'aura-ss.local';

export function placeholderEmailFor(firstName: string, taken: readonly string[]): string {
  const base = (firstName ?? '').toLowerCase().replace(/[^a-z]/g, '');
  if (!base) throw new Error('A placeholder email needs a first name with letters.');
  const used = new Set(taken.map((e) => e.toLowerCase()));
  for (let n = 1; ; n++) {
    const email = `${base}${n === 1 ? '' : n}.p2@${PLACEHOLDER_DOMAIN}`;
    if (!used.has(email)) return email;
  }
}

export function isPlaceholderEmail(email: string): boolean {
  return /^[a-z]+\d*\.p2@aura-ss\.local$/.test((email ?? '').trim().toLowerCase());
}
